import type { RecommendationResult } from '../../recommendations/types';
import type { Job } from '../components/JobCard';
import type { MatchProfileContext } from '../components/JobMatchExplainer';
import { mapScoreToBreakdown } from './mapScoreToBreakdown';

/** Build explainer payload from a job row + optional DB recommendation + profile. */
export function buildJobExplainerBreakdown(
  job: Pick<Job, 'matchScore' | 'matchedSkills' | 'missingSkills'>,
  rec?: RecommendationResult | null,
  profile?: MatchProfileContext | null,
) {
  const overall = job.matchScore ?? rec?.score ?? 0;
  return mapScoreToBreakdown({
    overall,
    breakdown: rec?.score_breakdown,
    matchedSkills: rec?.matched_skills ?? job.matchedSkills ?? [],
    missingSkills: rec?.missing_skills ?? job.missingSkills ?? [],
    summary: rec?.why_matched,
    profile: profile ?? undefined,
  });
}
